var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.575288 7.79946C0.0172216 8.35752 0.0172216 9.26382 0.575288 9.82189L7.71854 16.9651C8.27661 17.5232 9.18291 17.5232 9.74098 16.9651C10.299 16.4071 10.299 15.5008 9.74098 14.9427L5.03089 10.2371H18.7281C19.5183 10.2371 20.1567 9.59866 20.1567 8.80844C20.1567 8.01822 19.5183 7.37979 18.7281 7.37979H5.03536L9.73651 2.67417C10.2946 2.1161 10.2946 1.2098 9.73651 0.651735C9.17845 0.0936681 8.27215 0.0936681 7.71408 0.651735L0.570824 7.79499L0.575288 7.79946Z",
    fill: "#0D6E89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.8749aa220a5ef30b1d407e8ba7a2af48.svg";
export { ForwardRef as ReactComponent };